import { render } from "./S118093.vue?vue&type=template&id=14a4a8cf"
const script = {}
script.render = render

export default script